import DocPage from '../components/DocPage.jsx'
import { explainer } from '../content.js'

// The architecture explainer. The page TYPE moved to components/DocPage.jsx in
// P6-2, when /docs became the second page to want it — see that file for the
// "authored, not exported" rule, which applies to explainer.json's copy
// unchanged.

export default function Explainer() {
  return <DocPage doc={explainer} />
}
